export enum FirebaseAuthMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  FACEBOOK = 'facebook'
}

export enum RoomFormAction {
  CREATE = 'create',
  EDIT = 'edit',
  COPY = 'copy',
  REMOVE = 'remove'
}

export enum RoomSidebarOptions {
  ATTENDEES = 'attendees',
  CHAT = 'chat',
  SCENE_OBJECTS = 'scene-objects'
}

export enum PendingAttendeeStatus {
  WAITING = 'waiting',
  ALLOWED = 'allowed',
  DENIED = 'denied'
}

export enum RoomCameraContainer {
  ROOM = 'user-mirror-video',
  USER_SETTINGS = 'user-settings',
  SELFIE = 'user-selfie-video'
}

export enum DatabaseChildStatus {
  ADDED = 'added',
  CHANGED = 'changed',
  REMOVED = 'removed'
}

export enum EventUserStatus {
  PENDING = 0,
  ONGOING = 1,
  DONE = 2,
  REMOVED = 3
}

export enum RoomTopBarType {
  REMAINING_TIME = 'remainingTime',
  QUEUE_STATUS = 'queueStatus',
  HIDDEN = 'hidden'
}

export enum FanPopupType {
  WELCOME = 'welcome',
  FAREWELL = 'farewell'
}

export enum SoundPath {
  DING = '/assets/audio/ding.wav',
  DING_MP3 = '/assets/audio/ding.mp3',
  COUNT_DOWN = '/assets/audio/countdown.wav',
  MESSAGE_NOTIFICATION = '/assets/audio/message-notification.wav',
  ALERT_NOTIFICATION = '/assets/audio/alert-notification.wav'
}

export enum DefaultImage {
  BLANK = '/assets/images/blank.png',
  BLANK_BORDER = '/assets/images/blank-border.png',
  RED_BORDER = '/assets/images/red-border.png',
  LINKROOM = '/assets/images/logo.svg',
  LINKROOM_ICON = '/assets/images/icon-logo-loading.svg',
  VIDEO = '/assets/images/noVideoLogo.png'
}

export enum SceneObjectType {
  COLLIDER = 'collider',
  MODEL = 'model'
}

export enum RoomUrlType {
  ROOM = 'room',
  PRESENTATION = 'presentation',
  SINGLE_LOCAL = 'single-local'
}

export enum SelfieCameraStatus {
  TAKE_AGAIN = 'take-again',
  SNAP = 'snap',
  TAKE_PHOTO = 'take-photo'
}

export enum RoomType {
  LINKROOM = 'Linkroom',
  PIXEL_STREAMING = 'Pixel Streaming',
  CUSTOM_WORLDS = 'Custom Worlds'
}

export enum NetworkMessageCode {
  SEND_MESSAGE_TO_PLAYER = 81,
  ROOM_EVENT = 203
}

export enum GalleryFieldType {
  AR_MODEL = 'AR Model',
  IMAGE = 'Image',
  IMAGE_GALLERY = 'Image Gallery',
  MULTILINE_TEXT = 'Multiline Text',
  QR_CODE = 'QR Code',
  SCREEN = 'Screen',
  TEXT = 'Text',
  VIDEO = 'Video',
  ReusableObject = "Reusable object"
}

export enum SceneObjectCarouselType {
  IMAGE = 'Image',
  QR_CODE = 'QR Code',
  VIDEO = 'Video',
  AR_MODEL = 'AR Model'
}

export enum SelectedObjectStatus {
  STAND_BY = 'stand by',
  ORBITING = 'orbiting',
  FOCUSING = 'focusing'
}

export enum SceneObjectAction {
  ORBIT = 'orbit',
  EXIT_ORBIT = 'exitOrbit',
  TRANSLATE = 'translate',
  ROTATE = 'rotate',
  SCALE = 'scale',
  FOCUS = 'focus',
  ANIMATE = 'animated',
  LOCK = 'lock',
}

export enum KeyCode {
  // Function Keys
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',

  // Number Row
  DIGIT_0 = 'Digit0',
  DIGIT_1 = 'Digit1',
  DIGIT_2 = 'Digit2',
  DIGIT_3 = 'Digit3',
  DIGIT_4 = 'Digit4',
  DIGIT_5 = 'Digit5',
  DIGIT_6 = 'Digit6',
  DIGIT_7 = 'Digit7',
  DIGIT_8 = 'Digit8',
  DIGIT_9 = 'Digit9',

  // Alphabet Keys
  KEY_A = 'KeyA',
  KEY_B = 'KeyB',
  KEY_C = 'KeyC',
  KEY_D = 'KeyD',
  KEY_E = 'KeyE',
  KEY_F = 'KeyF',
  KEY_G = 'KeyG',
  KEY_H = 'KeyH',
  KEY_I = 'KeyI',
  KEY_J = 'KeyJ',
  KEY_K = 'KeyK',
  KEY_L = 'KeyL',
  KEY_M = 'KeyM',
  KEY_N = 'KeyN',
  KEY_O = 'KeyO',
  KEY_P = 'KeyP',
  KEY_Q = 'KeyQ',
  KEY_R = 'KeyR',
  KEY_S = 'KeyS',
  KEY_T = 'KeyT',
  KEY_U = 'KeyU',
  KEY_V = 'KeyV',
  KEY_W = 'KeyW',
  KEY_X = 'KeyX',
  KEY_Y = 'KeyY',
  KEY_Z = 'KeyZ',

  // Numpad Keys
  NUMPAD_0 = 'Numpad0',
  NUMPAD_1 = 'Numpad1',
  NUMPAD_2 = 'Numpad2',
  NUMPAD_3 = 'Numpad3',
  NUMPAD_4 = 'Numpad4',
  NUMPAD_5 = 'Numpad5',
  NUMPAD_6 = 'Numpad6',
  NUMPAD_7 = 'Numpad7',
  NUMPAD_8 = 'Numpad8',
  NUMPAD_9 = 'Numpad9',
  NUMPAD_ADD = 'NumpadAdd',
  NUMPAD_SUBTRACT = 'NumpadSubtract',
  NUMPAD_MULTIPLY = 'NumpadMultiply',
  NUMPAD_DIVIDE = 'NumpadDivide',
  NUMPAD_DECIMAL = 'NumpadDecimal',
  NUMPAD_ENTER = 'NumpadEnter',

  // Arrow Keys
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',

  // Modifier Keys
  SHIFT_LEFT = 'ShiftLeft',
  SHIFT_RIGHT = 'ShiftRight',
  CONTROL_LEFT = 'ControlLeft',
  CONTROL_RIGHT = 'ControlRight',
  ALT_LEFT = 'AltLeft',
  ALT_RIGHT = 'AltRight',
  META_LEFT = 'MetaLeft', // Windows/Command key on the left
  META_RIGHT = 'MetaRight', // Windows/Command key on the right

  // Special Keys
  ESCAPE = 'Escape',
  TAB = 'Tab',
  CAPS_LOCK = 'CapsLock',
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
  SPACE = 'Space',
  DELETE = 'Delete',
  INSERT = 'Insert',
  HOME = 'Home',
  END = 'End',
  PAGE_UP = 'PageUp',
  PAGE_DOWN = 'PageDown',

  // Brackets and Symbols
  BACKQUOTE = 'Backquote', // `
  MINUS = 'Minus', // -
  EQUAL = 'Equal', // =
  BRACKET_LEFT = 'BracketLeft', // [
  BRACKET_RIGHT = 'BracketRight', // ]
  BACKSLASH = 'Backslash', // \
  SEMICOLON = 'Semicolon', // ;
  QUOTE = 'Quote', // '
  COMMA = 'Comma', // ,
  PERIOD = 'Period', // .
  SLASH = 'Slash' // /
}

export enum RoomEventType {
  CHAT_ACTIVE = 'chat-active',
  CHAT_MESSAGE_REMOVE = 'chat-message-remove',
  CHAT_MESSAGE_REMOVE_ATTENDEE_ALL = 'chat-message-remove-attendee-all',

  ROOM_PRIVACY = 'room-privacy',
  SCENE_OBJECT_NAME = 'scene-object-name',

  REQUEST_SHARE_VIDEO = 'request-share-video',
  REQUEST_SHARE_SCREEN = 'request-share-screen',

  RESPONSE_SHARE_VIDEO = 'response-share-video',
  RESPONSE_SHARE_SCREEN = 'response-share-screen',

  ATTENDEE_NAME = 'attendee-name',
  ATTENDEE_MUTE = 'attendee-mute',
  ATTENDEE_REQ_UNMUTE = 'attendee-req-unmute',
  ATTENDEE_REMOVE = 'attendee-remove',
  ATTENDEE_SEND_MESSAGE = 'attendee-send-message',
  ATTENDEE_STOP_SCREEN_SHARE = 'attendee-stop-screen-share',
  ATTENDEE_REVOKE_PROJECTOR_USAGE = 'attendee-revoke-projector-usage',
  ATTENDEE_ALLOW_PROJECTOR_USAGE = 'attendee-allow-projector-usage',
  ATTENDEE_PROMOTE_TO_HOST = 'attendee-promote-to-host',
  ATTENDEE_NEW_HOST = 'attendee-new-host',
  ATTENDEE_DEMOTE_TO_GUEST = 'attendee-demote-to-guest',
  ATTENDEE_DEMOTE_TO_GUEST_PROPAGATION = 'attendee-demote-to-guest-propagation',
  ATTENDEE_GO_TO_POSITION = 'attendee-go-to-position',
  ATTENDEE_HOST_PROJECTORS_ENABLED = 'attendee-host-projectors-enabled',
  ATTENDEES_DISABLE_PROJECTORS = 'attendees-disable-projectors',
  ATTENDEES_ENABLE_PROJECTORS = 'attendees-enable-projectors',

  HOST_ACTION_MUTE_ALL = 'host-action-mute-all',
  HOST_ACTION_ENABLE_UNMUTE_ALL = 'host-action-enable-unmute-all',
  HOST_ACTION_FREEZE = 'host-action-freeze',
  HOST_ACTION_UNFREEZE = 'host-action-unfreeze'
}

export enum AttendeeOption {
  MUTE = 'mute',
  UNMUTE = 'unmute',
  REMOVE = 'remove',
  REVOKE_PROJECTOR_USAGE = 'revoke-projector-usage',
  ALLOW_PROJECTOR_USAGE = 'allow-projector-usage',
  STOP_SCREEN_SHARE = 'stop-screen-share',
  SEND_MESSAGE = 'send-message',
  PROMOTE_TO_HOST = 'promote-to-host',
  DEMOTE_TO_GUEST = 'demote-to-guest',
  GO_TO_POSITION = 'go-to-position'
}

export enum ChatMessageOption {
  REMOVE = 'remove',
  REMOVE_ALL_ATTENDEE = 'remove-all-attendee',
  GO_TO_POSITION = 'go-to-position'
}

export enum ConnectionDiagnosticMetricType {
  LATENCY = 'latency',
  JITTER = 'Jitter',
  PACKAGE_LOSS = 'package-loss',
  SPEAKER_DELAY = 'speaker-delay'
}

export enum ShareScreenOption {
  SCREEN = 'screen',
  VIDEO = 'video'
}

export enum ChatMessageType {
  MESSAGE = 'message',
  NOTIFICATION = 'notification'
}

export enum KeyEventType {
  KEY_UP = 'keyup',
  KEY_DOWN = 'keydown'
}

export enum OnboardingSteps {
  NAVIGATION = 'navigation',
  LOOK_AROUND = 'look-around',
  CLICK_OBJECT = 'click-object',
  TIPS = 'tips'
}
